module.exports = __webpack_public_path__ + "static/media/social-ok.261a3eb3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/social-ok.svg
// module id = 349
// module chunks = 0